import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { CircleIcon, FlexColumn, PromptClick } from '@ubeya/shared-web/components';
import { ReactComponent as CloseIcon } from '@ubeya/shared-web/assets/close-big.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Container = styled.div`
  margin: 6px;
`;

const Hour = styled.div`
  margin-right: 10px;
  font-size: 13px;
  flex: 1;
`;

const Content = styled(FlexColumn)`
  padding: 8px 10px;
  align-items: left;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.redNegative};
  border-radius: 4px;
  width: 100px;
  position: relative;
`;

const CloseButton = styled(CircleIcon)`
  height: 28px;
  width: 28px;
  position: absolute;
  right: 0;
  margin-left: 10px;
`;

export const TimeOffItemChip = ({ mappedTimeOffRequestOptions, id, jobTypeId, onDeletePeriod }) => {
  const { t } = useContext(ConfigContext);

  const onClick = useCallback(() => onDeletePeriod({ id, type: 'timeoff' }), [id, onDeletePeriod]);

  return (
    <Container>
      <Content>
        <Hour>{t(mappedTimeOffRequestOptions?.[jobTypeId]?.slug || '')}</Hour>
        <PromptClick onClick={onClick} body="areYouSureYouWantToDeleteTimeOff" confirmText="yes" usePortal>
          <CloseButton icon={CloseIcon} />
        </PromptClick>
      </Content>
    </Container>
  );
};
